import React from "react";

const groups = [
    {
        label: "Event Agencies",
        body: "Stronger proposal visuals, pitch support and client-facing concept material.",
    },
    {
        label: "Production Companies",
        body: "Spatial support before build, supplier conversations and early-stage planning.",
    },
    {
        label: "Event Planners",
        body: "Helping private or corporate clients understand a concept before committing.",
    },
    {
        label: "Brands",
        body: "Visualising activations, launches, pop-ups, branded moments and temporary experiences.",
    },
    {
        label: "Venues",
        body: "Showing what a space can become for events, launches, dinners, parties or activations.",
    },
    {
        label: "Scenic Builders & Suppliers",
        body: "Clearer conversations around scale, finishes, layout, fabrication and installation.",
    },
    {
        label: "Private Clients",
        body: "Seeing and understanding an event concept before it is built.",
    },
];

export default function WhoFor() {
    return (
        <section
            id="who-for"
            data-testid="who-for-section"
            className="section-pad bg-foreground/[0.02] border-y border-border"
        >
            <div className="container-edge">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <h2
                            data-testid="who-for-heading"
                            className="font-display text-4xl md:text-5xl lg:text-[56px] tracking-tight font-medium leading-[1.04] text-balance"
                        >
                            Supporting the people who{" "}
                            <span className="italic font-normal text-champagne">
                                make events happen.
                            </span>
                        </h2>
                        <p className="mt-8 text-foreground/70 text-[14px] leading-relaxed max-w-md">
                            I can work independently or as part of a wider creative,
                            planning or production team — adapting to the
                            information, stage and pace of your project.
                        </p>
                    </div>
                    <div className="md:col-span-7">
                        <ul className="border-t border-border">
                            {groups.map((g, i) => (
                                <li
                                    key={g.label}
                                    data-testid={`who-for-item-${i}`}
                                    className="group grid grid-cols-1 md:grid-cols-12 gap-4 py-6 md:py-7 border-b border-border hover:pl-2 transition-all duration-300"
                                >
                                    <div className="md:col-span-5 font-display text-2xl md:text-3xl font-medium tracking-tight">
                                        {g.label}
                                    </div>
                                    <div className="md:col-span-7 text-foreground/70 text-[14px] leading-relaxed self-center">
                                        {g.body}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
